import { useState } from "react";
import Subheader from "@components/layout/Subheader";
import { Accordion, accordionClasses, AccordionDetails, AccordionGroup, AccordionSummary, accordionSummaryClasses, Box, Button, LinearProgress, ListItemContent, ListItemDecorator, Tab, TabList, TabPanel, Tabs, Typography } from "@mui/joy";
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import RadioButtonUncheckedRoundedIcon from '@mui/icons-material/RadioButtonUncheckedRounded';
import RadioButtonCheckedRoundedIcon from '@mui/icons-material/RadioButtonCheckedRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { Form } from "@components/forms/Form";
import { AddRowButton } from "@components/objects/AddRowButton";
import { NewBusinesses } from "@components/rapid-reinvestment/NewBusinesses";
import { ClosedBusinesses } from "@components/rapid-reinvestment/ClosedBusinesses";
import { RelocatedBusinesses } from "@components/rapid-reinvestment/RelocatedBusinesses";
import { EmployeeChanges } from "@components/rapid-reinvestment/EmployeeChanges";
import { GrantsReceived } from "@components/rapid-reinvestment/GrantsReceived";
import { EventsHeld } from "@components/rapid-reinvestment/EventsHeld";
import { TrainingsHeld } from "@components/rapid-reinvestment/TrainingsHeld";
import { PublicImprovements } from "@components/rapid-reinvestment/PublicImprovements";
import { PublicInvestments } from "@components/rapid-reinvestment/PublicInvestments";
import { Overview } from "@components/rapid-reinvestment/Overview";
import { PropertySales } from "@components/rapid-reinvestment/PropertySales";
import { PropertyImprovements } from "@components/rapid-reinvestment/PropertyImprovements";
import { NewResidentialUnits } from "@components/rapid-reinvestment/NewResidentialUnits";
import { NewProperties } from "@components/rapid-reinvestment/NewProperties";
import { LostProperties } from "@components/rapid-reinvestment/LostProperties";
import { VolunteerHours } from "@components/rapid-reinvestment/VolunteerHours";
import { Review } from "@components/rapid-reinvestment/Review";
import { useCreate } from "@api/crudService";
import toast from "react-hot-toast";
import ConfettiExplosion from "react-confetti-explosion";
import { useDocumentTitle } from "@uidotdev/usehooks";
import { events } from "@utils/analytics";

// todo: move to types file
type NullableString = string|null;

interface ReinvestmentSectionDictionary {

}


/*
type AlternativeLayout = {
    [K in keyof BreakpointDictionary]?: AvailableBreakpoint[];
}
*/

const data = [
    {
        value: 'overview',
        label: 'Overview',
        color: 'default',
        // description: <>Enter the list of new businesses. These businesses should be opening their doors for the first time, and not an existing business which has relocated.</>,
        Component: Overview,//(props) => <NewBusinesses {...props} />,
    },
    {
        value: 'new-businesses',
        label: 'New Businesses',
        color: 'business',
        description: <>Enter the list of new businesses. These businesses should be opening their doors for the first time, and not an existing business which has relocated.</>,
        Component: NewBusinesses,//(props) => <NewBusinesses {...props} />,
    },
    {
        value: 'closed-businesses',
        label: 'Closed Businesses',
        color: 'business',
        description: <>Enter the list of closed businesses. These businesses should be closing their doors permanently, and not an existing business which has relocated.</>,
        Component: ClosedBusinesses,//(props) => <ClosedBusinesses {...props} />,
    },
    {
        value: 'relocated-businesses',
        label: 'Relocated Businesses',
        color: 'business',
        description: <>Enter the list of relocated businesses. These should still be in business and be moving in or out of the district.</>,
        Component: RelocatedBusinesses,//(props) => <ClosedBusinesses {...props} />,
    },
    {
        value: 'employee-changes',
        label: 'Employee Changes',
        color: 'business',
        description: <>Select the business from the list and enter the current number of employees for each role (FT, PT, Seasonal) and the date. </>,
        Component: EmployeeChanges,
    },

    {
        value: 'grants',
        label: 'Grants Received',
        color: 'default',
        description: <>Enter the grant(s) your organization has applied for, or select the grants applied for to mark them as awarded.</>,
        Component: GrantsReceived,
    },
    {
        value: 'events',
        label: 'Events Held',
        color: 'event',
        description: <>Enter the events held in your district.</>,
        Component: EventsHeld,
    },
    {
        value: 'trainings',
        label: 'Trainings Held',
        color: 'default',
        description: <>Enter the information for trainings attended by your staff and volunteers.</>,
        Component: TrainingsHeld,
    },
    {
        value: 'public-improvements',
        label: 'Public Improvements',
        color: 'default',
        description: <>Enter the public projects completed within your district.</>,
        Component: PublicImprovements,
    },
    {
        value: 'public-investments',
        label: 'Public Investments',
        color: 'default',
        description: <>Enter the public investments made in your organization.</>,
        Component: PublicInvestments,
    },

    {
        value: 'property-sales',
        label: 'Property Sales',
        color: 'property',
        description: <>Enter the list of properties sold in your district. These should be properties already in your district.</>,
        Component: PropertySales,
    },
    {
        value: 'property-improvements',
        label: 'Property Improvements',
        color: 'property',
        description: <>Enter the list of property improvements to your district. These are physical enhancements to the property.</>,
        Component: PropertyImprovements,
    },
    {
        value: 'new-residential',
        label: 'New Residential Units',
        color: 'property',
        description: <>Enter the list of New Residential Units. These should be units being added to existing properties.</>,
        Component: NewResidentialUnits,
    },
    {
        value: 'new-properties',
        label: 'New Properties',
        color: 'property',
        description: <>Enter the list of new property construction within your district.</>,
        Component: NewProperties,
    },
    {
        value: 'lost-properties',
        label: 'Lost Properties',
        color: 'property',
        description: <>Enter the list of properties lost within your district.</>,
        Component: LostProperties,
    },
    {
        value: 'volunteer-hours',
        label: 'Volunteer Hours',
        color: 'default',
        description: <>Enter the list of volunteer hours donated to your organization.<br/>Note: If you leave the Contacts field blank, time will be assigned to a generic contact named "REINVESTMENT STAT VOLUNTEER HOURS".</>,
        Component: VolunteerHours,
    },

    {
        value: 'review',
        label: 'Review & Submit',
        color: 'default',
        Component: Review,
    },
];

let completedSections = {}
let sections = {};
for(const sectionIndex in data) {
    const section = data[sectionIndex];
    sections[section.value] = {
        open: sectionIndex === 0,// false,
        complete: false,
    }

    completedSections[section.value] = false;
};

// defaultSections[data[0].value].open = true;

function PaginateButtons({
    index,
    section,
    setActiveSection,
    completed,
    setCompleted,

    // isFinalPage = false,
    onComplete = () => {},
}:{
    index:number,
    section:Object,
    setActiveSection:Function,
    completed:Object,
    setCompleted:Function
}) {
    const isFinalPage = index === data.length-1;


    const onPrev = () => {
        setActiveSection(index-1);
    };

    const onNext = () => {
        const _completed = completed;
        _completed[section.value] = true;
        setCompleted(_completed);

        setActiveSection(index+1);
    };

    return (
        <Box sx={{display: 'flex', justifyContent: 'space-between', mt: 1.5}}>
            <Button
                variant="outlined"
                color="neutral"
                size="sm"
                onClick={onPrev}
                disabled={index === 0}
            >
                Previous
            </Button>

            <Button
                // variant="plain"
                // color="neutral"
                size="sm"
                onClick={!isFinalPage ? onNext : undefined}
                // disabled={index === data.length-1}
                type={isFinalPage ? 'submit' : 'button'}
            >
                {isFinalPage ? 'Submit' : 'Next'}
            </Button>
        </Box>
    );
}

export default function RapidReinvestment() {
    useDocumentTitle(`Rapid Reinvestment | Maestro Community Manager`);

    const [exploding, setExploding] = useState<boolean>(false);

    // const [activeTab, setActiveTab] = useState<NullableString>(data[0].value);//('');
    // const [sections, setSections] = useState(defaultSections);
    const [activeSection, setActiveSection] = useState(0);
    const [completed, setCompleted] = useState(completedSections);

    const [errors, setErrors] = useState([]);

    const totalCompletedSections = Object.values(completed).filter(section => section === true).length;
    const totalSections = Object.keys(sections).length;
    const progress = totalCompletedSections / totalSections;

    let activeTabInfo = data[activeSection];// data.find(row => row.value === activeTab);
    let activeBorderColor = activeTabInfo ? activeTabInfo.color : 'default';

    const mutation = useCreate({queryKey: ['rapid-reinvestment']});

    const onSubmit = (saveData, error) => {
        let newObj = {...saveData};

        // nuke anything that is to_be_deleted
        for(const key in newObj) {
            if(
                typeof newObj[key] !== 'object'
                || (newObj[key] instanceof Date) /*isValidDate(newObj[key])*/
                || !newObj[key]
            ) {
                continue;
            }

            let relationship = newObj[key];

            for(let i = relationship.length - 1; i >= 0; i--) {
                if(!!relationship[i].to_be_deleted) {
                    relationship.splice(i, 1);
                }
            }
        }

        /*
        if(typeof restProps.beforeSave === 'function') {
            newObj = restProps.beforeSave(newObj);
        }
        */

        const performUpdate = mutation.mutateAsync(newObj);

        toast.promise(performUpdate, {
            loading: 'Submitting...',
            success: `The reinvestment stats were submitted!`,
            error: `There was an error while submitting.`,
        });

        performUpdate.then((newData) => {
            events.rapidReinvestmentUsed();
            setErrors([]);
            setExploding(true);
            setTimeout(() => {
                setExploding(false);
                window.location.reload(); // empty out the form
            }, 2200);
        }).catch(({response}) => {
            const { data } = response;
            setErrors(data.failed);
        });

        // clear out form contents & go back to overview (or just reload)
    };

    return (<>
        {exploding && (<>
        <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
          <ConfettiExplosion />
        </div>
      </>)}
        <Subheader
            title={'Rapid Reinvestment'}
            tint={'default'}
            subtitle={'Record your reinvestment stats in one spot!'}
        >
        </Subheader>

        <Box sx={theme => ({
            // backgroundImage: `linear-gradient(180deg, ${theme.palette['default'][100]} 0%, white 100%);`,// : null,
            backgroundAttachment: 'fixed',
            minHeight: 'calc(100% - var(--Header-height))',
            p: 2,
        })}>
            <Form onSubmit={onSubmit} /*initialData={restProps?.initialData}*/>

            {/*
            <LinearProgress
                determinate
                value={progress * 100}
                sx={{backgroundColor: 'var(--joy-palette-background-backdrop)', mt: -2, mb: 2, position: 'sticky', zIndex: '100', top: '112px'}}
            />
            */}


        {/*
        <Tabs
            variant='plain'
            color='neutral'
            value={activeTab}
            onChange={(event, newValue: string) => {
                console.log(newValue);
                setActiveTab(newValue);
            }}
            sx={theme => ({
                bgcolor: 'transparent',
                // '--Tab-indicatorRadius': '12px'
                // borderRadius: 'md',
            })}
        >
          <TabList
            disableUnderline
            sx={theme => ({
                p: 0,//0.5,
                gap: 1,//0.5,
                // '--Tab-indicatorRadius': '12px'
                borderRadius: 'sm',
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottom: 4,
                borderBottomColor: `${theme.palette[activeBorderColor][600]}`
                // borderTopLeftRadius: 'xl',
                // borderBottomRightRadius: 'xl',
            })}
          >
            {data.map((tab, index) => (
              <Tab
                key={index}
                value={tab.value}
                disableIndicator
                color={tab.color}
                variant={activeTab === tab.value ? 'solid' : 'soft'}
                // variant="solid"
                sx={theme => ({
                    boxShadow: 'md',
                    // borderTopColor: `${theme.palette[tab.color][activeTab === tab.value ? 600 : 500]} !important`,
                    // borderTopWidth: 4,
                    // bgcolor: activeTab === tab.value ? `${tab.color}.600` : `${tab.color}.400`,
                    backgroundColor: `${theme.palette[tab.color][activeTab === tab.value ? 600 : 500]} !important`,
                    // px: 2,
                    py: 0,//1,
                    color: 'white',
                    fontWeight: '600',
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    '&:hover': {
                        // bgcolor: activeTab === tab.value ? `${tab.color}.600` : `${tab.color}.500`,
                        backgroundColor: `${theme.palette[tab.color][activeTab === tab.value ? 600 : 600]} !important`,
                    }
                })}
                // sx={activeTab === tab.value ? {borderBottomLeftRadius: 0, borderBottomRightRadius: 0} : {}}
              >
                {tab.label}
                <ListItemDecorator
                    sx={theme => ({
                        /*
                        borderRight: 1,
                        borderRightColor: 'rgba(255,255,255,0.5)',
                        py: 1,
                        pr: 2,
                        mr: 2,
                        *\/

                        /*
                        borderRight: 1,
                        borderRightColor: theme.palette[tab.color][400],
                        py: 1,
                        pr: 1,
                        mr: 2,
                        ml: -1,
                        '--Icon-color': theme.palette[tab.color][300],
                        *\/

                        // borderLeft: 1,
                        // borderLeftColor: theme.palette[tab.color][400],
                        py: 1,
                        pl: 1,
                        // ml: 2,
                        // mr: -1,
                        '--Icon-color': theme.palette[tab.color][300],
                    })}
                >
                    {activeTab === tab.value && (<RadioButtonCheckedRoundedIcon/>)}
                    {activeTab !== tab.value && (<>
                        {sections[tab.value].complete === true && <CheckCircleOutlineRoundedIcon/>}
                        {sections[tab.value].complete !== true && <RadioButtonUncheckedRoundedIcon/>}
                    </>)}
                </ListItemDecorator>
              </Tab>
            ))}
          </TabList>
            {data.map((tab, index) => (
              <TabPanel key={index} value={tab.value}>
                {tab.render()}
              </TabPanel>
            ))}
        </Tabs>

        <div style={{height: '50px'}}/>
        */}

        <AccordionGroup
            sx={{
                // boxShadow: 'md',
                gap: 0.5,
                borderRadius: 'sm',

                '--List-gap': '6px',
                // maxWidth: 400,
                [`& .${accordionSummaryClasses.indicator}`]: {
                    transition: '0.2s',
                    transform: 'rotate(0deg)',
                },
                [`& .${accordionSummaryClasses.indicator} .arrow.MuiSvgIcon-root`]: {
                    transition: '0.2s',
                    transform: 'rotate(-90deg)',
                },
                [`& [aria-expanded="true"] .${accordionSummaryClasses.indicator} .arrow.MuiSvgIcon-root`]: {
                    transform: 'rotate(0deg)',
                },
                [`.${accordionClasses.root}`]: {
                    // marginBottom: '3px !important',
                }
            }}
        >
            {data.map((tab, index) => (
                <tab.Component
                    key={`${tab.value}-${index}`}

                    errors={errors}

                    sections={data}
                    completedSections={completed}
                    totalCompletedSections={totalCompletedSections}
                    totalSections={totalSections}

                    completed={completed[tab.value] === true}
                    expanded={activeSection === index}
                    index={index}
                    tint={tab.color}

                    relationship={tab.value}

                    title={tab.label}
                    startDecorator={!!tab?.description && <>
                        {!!tab?.description && (
                            <Typography fontSize={'md'}>
                                {tab.description}
                            </Typography>
                        )}
                    </>}
                    endDecorator={<>
                        {/* {tab.value !== 'review' && ( */}
                            <PaginateButtons
                            index={index}
                            section={tab}
                            setActiveSection={setActiveSection}
                            completed={completed}
                            setCompleted={setCompleted}

                            // onComplete={tab.value !== 'review' && doSubmit}
                            />
                        {/* )} */}
                    </>}

                    activeSection={activeSection}
                    setActiveSection={setActiveSection}
                />
            ))}
        </AccordionGroup>
        </Form>
        </Box>
    </>);
}
